
import { useNavigate } from 'react-router-dom';
import {useDispatch} from "react-redux"
import { deleteMovie } from '../store/actions';
import Swal from "sweetalert2"

function MovieRow({movie,i}){
    const navigate= useNavigate()
    const dispatch= useDispatch()

    const deletesMovie= (e,id)=>{
        e.preventDefault()
       dispatch(deleteMovie(id))
        navigate('/')
        Swal.fire({
            icon: 'success',
            title: 'Success delete genre'
        })
    }

    const editMovie= (e)=>{
       e.preventDefault()
       navigate(`/edit/${movie.id}`)
    }

    const detailMovie= (e)=>{
        e.preventDefault()
        navigate(`/movie/${movie.id}/${movie.slug}`)
    }
       
    return(
        <tr className="bg-white border-b dark:bg-gray-900 dark:border-gray-700">
        <td className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
           {i+1}
        </td>
        <td className="py-4 px-6">
            {movie.title}
        </td>
        <td className="py-4 px-6">
            {movie.slug}
        </td>
        <td className="py-4 px-6">
            {movie.synopsis}
        </td>
        <td className="py-4 px-6">
            {movie.rating}
        </td>
        <td className="py-4 px-6">
            {movie?.Genre?.name}
        </td>
        <td className="py-4 px-6">
            <img src={movie.imgUrl} alt="" width={"200px"}/>
        </td>
        <td className="py-4 px-6">
           <button onClick={detailMovie} className="bg-green-500 rounded-lg w-24 text-white h-6">Show Image</button>
        </td>
        <td className="py-4 px-6">
            <button className="font-medium text-blue-600 dark:text-blue-500 hover:text-blue-400" onClick={editMovie}>Edit</button>
            <button className="font-medium text-red-600 dark:text-red-500 hover:text-red-400" onClick={(e)=>deletesMovie(e,movie.id)}>Delete</button>
        </td>
    </tr>
    )
}

export default MovieRow